"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("../../utils/styled-components"));
var Tracking32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("defs", null,
        react_1.default.createElement("path", { d: "M9.717 2.55L22.56 8.731l4.73-2.186a.5.5 0 01.703.372L28 7v15.813a.5.5 0 01-.298.457l-14 6.187a.522.522 0 01-.248.041.468.468 0 01-.169-.047l-13-6.187A.5.5 0 010 22.813V7a.5.5 0 01.723-.448l9.749 4.853a.5.5 0 11-.446.895L1 7.807v14.69l12 5.711V13.78l-.547-.272a.5.5 0 01.445-.895l.61.302 2.835-1.31a.5.5 0 01.619.167l.045.078a.5.5 0 01-.244.663L14 13.79v14.442l13-5.745V7.782l-4.037 1.866a.499.499 0 01.037.19v5.73a.5.5 0 01-.313.463l-3.555 1.433a.5.5 0 01-.687-.464v-5.422L6.275 5.447a.5.5 0 01.45-.894l11.909 6 .058-.033 2.69-1.244L9.284 3.451l.434-.902zM22 10.091l-2.555 1.181v4.986L22 15.23v-5.137zm-7.3-8.545L.694 7.461a.5.5 0 01-.388-.922l14.21-6a.5.5 0 01.407.008l12.79 6a.5.5 0 11-.425.906L14.7 1.547z", id: "tracking-32_svg__a" })),
    react_1.default.createElement("g", { transform: "translate(2 1)", fill: "currentColor", fillRule: "evenodd" },
        react_1.default.createElement("mask", { id: "tracking-32_svg__b" },
            react_1.default.createElement("use", { xlinkHref: "#tracking-32_svg__a" })),
        react_1.default.createElement("use", { fillRule: "nonzero", xlinkHref: "#tracking-32_svg__a" }),
        react_1.default.createElement("g", { mask: "url(#tracking-32_svg__b)" },
            react_1.default.createElement("path", { d: "M-2-1h32v32H-2z" }))))); };
var StyledTracking32 = styled_components_1.default(Tracking32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledTracking32;
var templateObject_1;
//# sourceMappingURL=Tracking32.js.map